/**
 * 앱 유일의 로그 출구 (SYNC_SECURITY §15).
 * 로그에는 코드·식별자·숫자만 남긴다. 전사·상담내용·이름·secret은 절대 넘기지 않는다.
 * 이를 타입으로 강제하기 위해 context 값은 짧은 원시값만 허용하고, 긴 문자열은 잘라서 길이만 남긴다.
 */
type LogValue = string | number | boolean | null | undefined;
type LogContext = Record<string, LogValue>;

const MAX_VALUE_LEN = 64;

function sanitize(ctx: LogContext | undefined): LogContext | undefined {
  if (!ctx) return undefined;
  const out: LogContext = {};
  for (const [k, v] of Object.entries(ctx)) {
    out[k] = typeof v === 'string' && v.length > MAX_VALUE_LEN ? `[redacted:${v.length}]` : v;
  }
  return out;
}

export const logger = {
  info(code: string, ctx?: LogContext) {
    if (import.meta.env.DEV) console.info(code, sanitize(ctx));
  },
  warn(code: string, ctx?: LogContext) {
    console.warn(code, sanitize(ctx));
  },
  error(code: string, ctx?: LogContext) {
    console.error(code, sanitize(ctx));
  },
};
